import { TextWithCitations } from '@app/src/pages/Questionnaire/Accessor/Report/AiScreening/TextWithCitations'
import type { SearchResult } from '@app/src/types/resourceExplorer'
import { Stack } from '@mui/material'
import React from 'react'

interface AISummaryContentProps {
  text: string
  searchResults: SearchResult[]
  onSwitchToSources: () => void
}
export const AISummaryContent: React.FC<AISummaryContentProps> = ({
  text,
  searchResults,
  onSwitchToSources,
}: AISummaryContentProps) => {
  return (
    <Stack spacing={3}>
      <TextWithCitations text={text} searchResults={searchResults} onSwitchToSources={onSwitchToSources} />
    </Stack>
  )
}
